module.exports = __webpack_public_path__ + "img/delete-gray-icon.0c8e430b.svg";